export const environment = {
    GOOGLE_MAPS_API_KEY: "AIzaSyAJVXPX5d4lb2em8i19ZWDXfLwMhgUrXoM"
}